<template>
  <div>
    <form @submit.prevent="submit">
      <h1>Digite o código do seu passaporte.</h1>
      <p>Ele está impresso no seu crachá ;)</p>
      <div>
        <the-mask
          class="className"
          id="code"
          mask="AAA-A#A#-##"
          name="code"
          placeholder="XXX-X0X0-00"
          required="required"
          type="text"
          :value="code"
          v-model="typed_code"
          masked="true"
        />
      </div>
      <button class="ui-button--green" type="submit" :disabled="loading">
        <i :class="loading ? 'fa fa-spinner fa-pulse' : 'd-none'"></i>
        Resgatar meu certificado
      </button>
    </form>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  props: ["code"],
  data() {
    return {
      typed_code: "",
      loading: false,
    };
  },
  methods: {
    async submit() {
      this.loading = true;

      await Axios.get(`https://api.finbrasil.com.br/api/certificados/gerar/${this.typed_code}/verificar`)
        .then((response) => {
          window.open(`https://api.finbrasil.com.br/api/certificados/gerar/${this.typed_code}`);
        })
        .catch((error) => {
          this.$swal({
            title: "Oops :|",
            text: error.response.data.msg,
            confirmButtonText: "Ok",
          });
        });
      this.loading = false;
    },
  },
};
</script>
